module.exports = __webpack_public_path__ + "img_senzoku_04.99748d4016c61c7f6bc4.png";